var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "content" }, [
      _c("p", { staticClass: "title" }, [_vm._v("管理服务授权书")]),
      _c("p", [_c("strong", [_vm._v("委托方：数字证书订户及受托经办人")])]),
      _c("p", [_c("strong", [_vm._v("受托方：重庆易保全网络科技有限公司")])]),
      _c("p", [
        _vm._v(
          "委托方基于线上电子业务办理需求，自愿委托并授权受托方为其提供数字证书私钥托管服务，双方就相关权利义务作出如下确认与承诺："
        )
      ]),
      _c("p", [
        _vm._v(
          "\n    1.委托方通过包括但不限于点击确认、页面勾选、手写签名、电子签名等线上及线下任一方式或组合形式确认本授权书的，\n    即视为委托方真实意思表示，授权行为合法有效，委托方自愿接受本授权书全部条款约束。\n  "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n    2.受托方按照本授权约定，妥善托管委托方的数字证书私钥；\n    受托方仅在收到委托方业务操作指令、获得委托方明确授权的情况下，调用并使用对应私钥处理线上业务。\n  "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n    3.私钥托管期限与数字证书有效期一致，证书有效期届满、依法注销的，私钥托管服务随即终止。\n  "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n    4.委托方应妥善保管与私钥相关的账号、密码口令、验证码、设备权限、身份核验凭证等安全要素信息，不得转借、泄露、授权他人使用。\n  "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n    5.若委托方知悉证书私钥、与证书私钥相关的密码口令/验证码等安全要素信息已经或者可能已经损毁、\n    丢失、泄露时，应当立即告知并协助受托方完成证书私钥的撤销操作，并终止或中止使用相应证书。\n  "
        )
      ]),
      _c("p", [
        _vm._v(
          "\n    6.因委托方自身原因（如密码泄露、授权他人、操作失误、未及时告知等）导致的损失、法律纠纷、赔偿责任，均由委托方自行承担。\n  "
        )
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-330441c4", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-330441c4","hasScoped":true,"transformToRequire":{"video":"src","source":"src","object":"src","embed":"src"},"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./components/protocol/pItems/PrivateKeyManage.vue
// module id = LD2u
// module chunks = 39 51 74 82 83 91